module.exports = __webpack_public_path__ + "static/media/prv1.f6936fb3.jpg";